import { storeLocatorApiClient } from './index'

const BASE_PATH = '/storelocator/api/shops/'

const DEFAULT_DISTANCE_BY_COUNTRY = {
  Nederland: 20,
  Belgie: 20,
  België: 20, // Added with special char too just in case the naming is changed later on
  Polska: 50
}

const getDefaultDistance = (country) => DEFAULT_DISTANCE_BY_COUNTRY[country]

const buildSearchParams = ({
  country = 'Nederland',
  city,
  postal_code,
  province,
  distance
}) => {
  if (!city && !postal_code) {
    console.error('Postcode or city required to get store locations from api')
  }

  const resolvedDistance = distance || getDefaultDistance(country)

  return {
    country,
    ...(city ? { city } : {}),
    ...(!city && postal_code ? { postal_code } : {}),
    ...(province ? { province } : {}),
    ...(resolvedDistance ? { distance: resolvedDistance } : {})
  }
}

export default {
  async getStoreLocations(params) {
    return await storeLocatorApiClient.get(BASE_PATH, {
      params: buildSearchParams(params)
    })
  }
}
